module.exports = __webpack_public_path__ + "static/media/bullhorn.5bbb8a8e.svg";